export const ENTER = 13;
export const ESCAPE = 27;
export const DOWN = 40;
export const J = 74;
export const LEFT = 37;
export const RIGHT = 39;
export const SPACE = 32;
export const TAB = 9;
export const UP = 38;
